import React, { useState, useEffect, useMemo, useRef } from 'react';
import Warning from '../warning/warning';
import Play from '../play/play';
import GalleryVN from '../galleryVN/galleryVN';
import NovelMenu from '../novelMenu/novelMenu';
import Credits from '../credits/credits';
import plot from '../../services/plot';
import achievements from'../../services/achievements'

function App() {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [navigation, setNavigation] = useState( isLS ? localStorage.getItem('navigation') === null ? 0 : parseInt(localStorage.getItem('navigation')) : 0);
  const [step, setStep] = useState( isLS ? localStorage.getItem('step') === null? 0 : parseInt(localStorage.getItem('step')) : 0 );
  const [gallery, setGallery] = useState( isLS ? localStorage.getItem('gallery') === null ? 0 : new Map(JSON.parse(localStorage.getItem('gallery'))) : 0);
  let state = useRef(isLS ? localStorage.getItem('state') === null ? new Array() : JSON.parse(localStorage.getItem('state')) : new Array());
  let achievementsSave = useRef(isLS ? localStorage.getItem('achievementsSave') === null ? achievements : JSON.parse(localStorage.getItem('achievementsSave')) : achievements);

  useEffect(() => {
    for(let i = 0;i<achievementsSave.current.length;i++){
      if(achievementsSave.current[i][1] !== achievements[i][1]){
        achievementsSave.current[i][1] = achievements[i][1];
      }
    }
    localStorage.setItem('achievementsSave', JSON.stringify(achievementsSave.current));
    const map = new Map();
    if(/*gallery === 0*/true){
      for(let key in plot){
        if(plot[key].plot){
        for(let k in plot[key].plot){
          if(plot[key].plot[k].img && plot[key].plot[k].gallery){
        map.set(plot[key].plot[k].img, '0');
        }
        }
        }
        if(plot[key].plotAlt){
        for(let k in plot[key].plotAlt){
          if(plot[key].plotAlt[k].img && plot[key].plotAlt[k].gallery){
        map.set(plot[key].plotAlt[k].img, '0');
        }
        }
        }
        if(plot[key].messages){
        for(let k in plot[key].messages){
          if(plot[key].messages[k].img && plot[key].messages[k].gallery){
        map.set(plot[key].messages[k].img, '0');
        }
        }
        }
        if(plot[key].messagesAlt){
        for(let k in plot[key].messagesAlt){
          if(plot[key].messagesAlt[k].img && plot[key].messagesAlt[k].gallery){
        map.set(plot[key].messagesAlt[k].img, '0');
        }
        }
        }
        if(plot[key].blkscrn && plot[key].chapter){
        map.set("chapter"+plot[key].chapter,"Chapter "+plot[key].chapter);
        }
      }
    }
    if(isLS){
    localStorage.setItem('gallery', JSON.stringify(Array.from(map.entries())));
    if(step == 0){
      localStorage.setItem('step', step);
    }

    }
    setGallery(map);
},[]);

  function goPlay(){
setTimeout(go,300);
    function go(){
    if(isLS){
    localStorage.setItem('navigation', 2);
    }
    setNavigation(2);
  }
  }
  function goMenu(){
    if(isLS){
    localStorage.setItem('navigation', 1);
    }
    setNavigation(1);
  }
  function goToGallery(){
    if(isLS){
    localStorage.setItem('navigation', 4);
    }
    setNavigation(4);
  }
  function goToCredits(){
    if(isLS){
    localStorage.setItem('navigation', 5);
    }
    setNavigation(5);
  }

  if(navigation !== null && navigation === 1){
    return (
      <NovelMenu goPlay={goPlay} goToGallery={goToGallery} goToCredits={goToCredits} step={step} setStep={setStep} state={state} achievementsSave={achievementsSave} plot={plot}/>
  );
  }
  if(navigation !== null && navigation === 2){
    return (
      <Play step={step} state={state} setStep={setStep} goMenu={goMenu} achievementsSave={achievementsSave}/>
  );
  }
  if(navigation !== null && navigation === 3){

}
  if(navigation !== null && navigation === 4){
    return (
      <GalleryVN goMenu={goMenu} gallery={gallery}/>
  );
  }
  if(navigation !== null && navigation === 5){
    return (
    <Credits goMenu={goMenu} />
  );
  }
  if(navigation !== null && navigation === 0){
    return (
      <Warning  goNext={goMenu} />
  );
  }

}

export function IsLSWork(){
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
}

export default App;
